import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableKogaRaport from "./ScroollTableKogaRaport";
import FooterOfRaportKoga from "./FooterOfRaportKoga";
import FillDetailKogaRaport from "./FillDetailKogaRaport";
const AllKogaRaport = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailKogaRaport />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScroollTableKogaRaport />
          </div>
        </div>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-lg-12 col-12">
            <FooterOfRaportKoga />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllKogaRaport;
